// extracted by mini-css-extract-plugin
export default {"ItemsWrapper":"SectionFiltersDropdown_ItemsWrapper__Lg1Im","Slide":"SectionFiltersDropdown_Slide__uKHdb","Active":"SectionFiltersDropdown_Active__-T3A4"};